import { AfterViewInit, Component, Input, OnInit, ViewChild, Renderer2, OnDestroy  } from '@angular/core';
import { SharedService } from 'src/app/directives/shared.service';
import { environment } from 'src/environments/environment';
import { LoginService } from '../../login/services/login.service';
import { BalanceService } from '../../services/balance.service';
import { CartServiceService } from '../../services/cart-service.service';
import { StorageService } from '../../services/storage.service';
import { DomController, iosTransitionAnimation, NavController, PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { PaisService } from '../../../generales/services/pais.service'
import { BalancePopoverComponent } from '../balance-popover/balance-popover.component';
import { UiService } from 'src/app/admin/service/ui.service';
import { MultioComponent } from '../multio/multio.component';
import { BolsaService } from '../../services/bolsa.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @ViewChild('header', { static: true }) header;
  @Input() noSearch = true;
  url = environment.url;
  susEvent:Subscription
  login = false;
  burgerIcon = '/assets/img/icons/ico-menu-burger-orange.svg';
  logoHeader = '/assets/img/logo/logo-header.png';
  usuarioIcon = '/assets/img/icons/ico-user-yellow.svg';
  usuarioLogined = this.usuarioIcon;
  carritoIcon = '/assets/img/icons/cart-yellow.svg';
  banderaIcon = '/assets/img/flags/venezuela.svg';
  db: any;
  username = '';
  spliterName = '';
  lastY = 300;
  selectedFlag:string;
  currency = '/assets/img/icons/moneda.svg'

  constructor(
    private router?: NavController,
    private storageService?: StorageService,
    private loginService?: LoginService,
    private balanceService?: BalanceService,
    public cartService?: CartServiceService,
    public sharedService?: SharedService,
    private renderer?: Renderer2, 
    private domCtrl?: DomController,
    private paisService?: PaisService,
    private popoverController?: PopoverController,
    private uiSv?: UiService,
    private bolsaSv?: BolsaService
  ) {
    this.getLocation()
  }

  async getLocation(){
    this.bolsaSv?.setCountry();
  }


  ngAfterViewInit() {
    this.cartService.setLength();
  }

  ionViewWillEnter() {
    this.loadProfilePhoto();
  }

  async loadProfilePhoto() {
    this.login = await this.storageService.get('token');
    if (this.login) {
      this.loginService.getUserData().subscribe((res) => {
        if (res.data[0].file) {
          this.usuarioLogined = `${this.url}/file/${res.data[0].file}`;
        }
      });
    }

    const username = await this.storageService.get('userLogin');
    if(!username) return;
    this.username = username.name;
    this.spliterName = this.username.split(' ')[0];
  }

  async ngOnInit() {
    this.selectedFlag = this.paisService.selectedCountry.img
    this.loadProfilePhoto();
    this.loginService.updateHeader.subscribe(emit => {
      this.loadProfilePhoto();
    });

    this.header = this.header.el;
    this.domCtrl.write(() => {
      this.renderer.setStyle(this.header, 'transition', 'transform 500ms');
    });

    this.susEvent = this.sharedService.emitScroll.subscribe(ev => {
      this.contentScroll(ev);
    });
  }

  destroy() {
    if(this.susEvent){
      this.susEvent.unsubscribe();
      this.renderer.removeStyle(this.header, 'transform');
      this.renderer.removeStyle(this.header, 'transition');
    } 
    
  }

  contentScroll(ev){
    if (ev.detail.scrollTop  > this.lastY) {
      this.domCtrl.write(() => {
        this.renderer.setStyle(this.header, 'transform', `translateY(-${ this.header.clientHeight }%)`);
        // this.renderer.setStyle(this.header, 'position', 'fixed');
      });
    } else {
      this.domCtrl.write(() => {
        // this.renderer.setStyle(this.header, 'margin-top', '0');
        this.renderer.setStyle(this.header, 'transform', 'translateY(0%)');
      });

    }

    if(ev.detail.scrollTop > 300){
      this.lastY = ev.detail.scrollTop;
    }else{
      this.lastY = 300;
    }

  }

  async OpenMulticurrency(ev){
    await this.uiSv.createPop( MultioComponent, { currency: true }, 'popMulti', ev );
  }

  goToRoute(route: string) {
    this.router.navigateRoot(route, {
      animation: iosTransitionAnimation
    });
  }

  async showStatics(target) {
    const event = target;
    if(!this.login){
      const login = await this.popoverController.create({
        component: BalancePopoverComponent,
        componentProps: { logined: false },
        event
      });
      login.present();
      return
    }
    this.balanceService.getUserBalance(
      target,
      this.usuarioLogined,
      this.username,
      true
    );
  }
  
}
